
import { Vue, Component, Prop } from "vue-property-decorator";
import PagedListBase, {
  PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import { UserDto, OrderRecordDto } from "@/api/service-proxies";

class PageUserRequest extends PagedRequestDto {
  name!: string;
  userName!: string;
  phoneNumber!: string;
}

@Component({})
export default class PaidRecord extends PagedListBase<
  PageUserRequest,
  UserDto
> {
  @Prop() orderRecords!: OrderRecordDto;

  getpage(finishCallback: Function): void {
    throw new Error("Method not implemented.");
  }

  created() {}
}
